<template>
	<div>
		<div style="color: #3e3e3e;
	  		font-size: 18px;margin-bottom: 15px;">产品管理>{{activeName=="one"?"剪发服务":""}}{{activeName=="two"?"染发服务":""}}</div>
		<el-tabs type="card" v-model="activeName">
			<el-tab-pane name="one" label="剪发服务">
				<list1></list1>
			</el-tab-pane>
			<!--<el-tab-pane name="two" label="烫染服务">
			<list4></list4>
      </el-tab-pane> -->
        <!-- <el-tab-pane name="two"  label="产品运营">
        <list3></list3>
      </el-tab-pane> -->
		</el-tabs>
	</div>
</template>
<script>
	import list1 from "./product_hair/product_hair1.vue"
	import list2 from "./product_hair/product_hair2.vue"
	import list3 from "./product_hair/product_hair3.vue"
	import list4 from "./product_hair/product_haircolor.vue"
	export default {
		components: {
			list1,
			list2,
			list3,
			list4
		},
		data() {
			return {
				numData: "",
				activeName: "one"
			};
		},
		created() {
			if (this.$route.query.id == 2) {
				localStorage.setItem('sid', this.$route.query.store)
				this.activeName = "two"
			}
		},
		methods: {
			// tabs切换点击事件
			tabsSwitch(id) {
				this.tabs.forEach((v, i) =>
					i === id ? (v.isActive = true) : (v.isActive = false)
				);
			},
		},
	};
</script>
<style lang="less" scoped>